import { FC } from 'react';

import {
  ForgotPasswordButtonStyled,
  LoginButtonStyled,
  LoginViewStyled,
  LogoWrapStyled,
} from './LoginView.styled';
import { NoopT } from 'declarations/types/common';

type LoginViewPropsT = {
  isLoginLoading: boolean;
  onLoginClick: NoopT;
  onForgotPasswordClick: NoopT;
};

const LoginView: FC<LoginViewPropsT> = ({
  onLoginClick,
  onForgotPasswordClick,
  isLoginLoading,
}) => {
  return (
    <LoginViewStyled direction="column">
      <LogoWrapStyled>
        <img src="/images/logo.png" alt="WarrCloud | Warranty Status Report" />
      </LogoWrapStyled>
      <LoginButtonStyled
        type="submit"
        size="xl"
        variant="contained"
        isLoading={isLoginLoading}
        onClick={onLoginClick}
      >
        Login
      </LoginButtonStyled>
      <ForgotPasswordButtonStyled variant="text" onClick={onForgotPasswordClick}>
        Forgot your password?
      </ForgotPasswordButtonStyled>
    </LoginViewStyled>
  );
};

export default LoginView;
